import clsx from 'clsx';
import { ReactNode } from 'react';

interface BundleBotComponentProps {
  children: ReactNode;
  className?: string;
}

interface BundleBotLinkProps extends BundleBotComponentProps {
  href?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
}

const BundleBotHeading = ({ children, className }: BundleBotComponentProps) => (
  <h4 className={clsx('bundleBot_heading', className)}>{children}</h4>
);

const BundleBotText = ({ children, className }: BundleBotComponentProps) => (
  <p className={clsx('bundleBot_text', className)}>{children}</p>
);

const BundleBotBold = ({ children, className }: BundleBotComponentProps) => (
  <b className={clsx('bundleBot_boldText', className)}>{children}</b>
);

const BundleBotLink = ({
  children,
  className,
  ...linkProps
}: BundleBotLinkProps) => (
  <a {...linkProps} className={clsx('bundleBot_link', className)}>
    {children}
  </a>
);

export { BundleBotHeading, BundleBotText, BundleBotBold, BundleBotLink };
